import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WizardN35EncuestadorService {

  idEmpresa: string;
  idUsuario: string;
idInfoUser: any;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.idInfoUser = infoUsu;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;

  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getAllStatus(anio: number){
    let datos: any = {fechaCertificar: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatuses + this.idEmpresa, datos);
  }

  guardaStatusStep(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  // New services

  getStatus(datos:any){
    let enviar = {
      productoId : datos
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getAllstatus+ this.idEmpresa, enviar);
  }

  saveStatus(datos){
    //let datos: any = {productoId: idproducto,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  getStatusModal(datos:any){
    this.obtienInfo();
    if (this.idInfoUser.level!=6) {
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getBanderaVideo + this.idEmpresa, datos);
    }else{
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getBanderaVideo + localStorage.getItem('companyID'), datos);

    }
  }
  updateStatusModal(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.setBanderaVideo + this.idEmpresa, datos);
  }

  pruebacolaboradores(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, data);
  }

  sendCheck(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendCheck + this.idEmpresa, data);
  }

  getCheck(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getChecked + this.idEmpresa, data);
  }



}
